import type { SourcedRollModifier } from "@/lib/kernel/entity-hydration/roll-modifier/types";
import { formatRollContributors } from "./format-roll-contributors";

export function RollLineRow({
  label,
  mods,
}: {
  label: string;
  mods: readonly SourcedRollModifier[];
}) {
  const { total, sourceParts, diceParts, advLabel } =
    formatRollContributors(mods);
  const subParts = [...sourceParts, ...diceParts];
  if (advLabel) {
    subParts.push(advLabel === "adv" ? "advantage" : "disadvantage");
  }
  const sub = subParts.join(" · ");
  return (
    <div className="flex items-baseline justify-between border-border/50 border-b py-1.5">
      <div>
        <span className="text-foreground text-sm capitalize">{label}</span>
        {sub && <div className="text-muted-foreground text-xs">{sub}</div>}
      </div>
      <span className="font-bold text-foreground text-lg">
        {total >= 0 ? `+${total}` : total}
      </span>
    </div>
  );
}
